import { createSlice } from '@reduxjs/toolkit'
import storageFactory from '../../Common/Services/Storage'
const Storage = storageFactory()

const slice = createSlice({
  name: 'theme',
  initialState: { mode: Storage.get('themeMode', 'light'), utcEnabled: Storage.get('utcEnabled', false) },
  reducers: {
    setThemeMode: (state, { payload }) => {
      state.mode = payload
      Storage.save('themeMode', payload)
    },
    setUtcEnabled: (state, { payload }) => {
      state.utcEnabled = payload
      Storage.save('utcEnabled', payload)
    },
  },
})

export const { setThemeMode, setUtcEnabled } = slice.actions

export default slice.reducer

export const selectThemeMode = (state) => state.ui.theme.mode
export const selectUtcEnabled = (state) => state.ui.theme.utcEnabled
